import styled from 'styled-components'

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
  margin-bottom: 8px;
`

export const Input = styled.input`
  margin-right: 6px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`

export const Label = styled.label`
  cursor: pointer;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.gray70};
`
